import { useState, useEffect, useCallback } from 'react';
import { trainingApi, TrainingUser } from '../services/trainingApi';

const STORAGE_KEY = 'trainingUser';

export function useTrainingUser() {
  const [user, setUser] = useState<TrainingUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        setUser(JSON.parse(raw));
      }
    } catch {
      // ignore
    }
    setIsLoading(false);
  }, []);

  const registrar = useCallback(
    async (payload: {
      nombre: string; email: string; empresa: string;
      rol:
        | 'administrador'
        | 'operador'
        | 'supervisor'
        | 'encargado_inventario';
      telefono?: string;
    }) => {
      const u = await trainingApi.registrarUsuario(payload);
      const clean: TrainingUser = {
        id: u.id,
        nombre: u.nombre,
        email: u.email,
        empresa: u.empresa,
        rol: u.rol,
        telefono: u.telefono ?? null,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
      setUser(clean);
      return clean;
    },
    []
  );

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setUser(null);
  }, []);

  return { user, isLoading, registrar, logout, isAuthenticated: !!user };
}
